import React from "react";
import { ModalBody, Form, FormGroup, Label } from "reactstrap";
import Select from "react-select";
import { useSelector } from 'react-redux';
import { getTranslation, BodyModalLanguages } from "./language";

function BodyModal({
  membersOfGroup,
  agent,
  setAgent,
  contactSelected,
  currentUser,
  teams,
}) {
  const language = useSelector((state) => state.Group.language);
  const currentGroup = useSelector((state) => state.Group.currentGroup);
  const translate = (key) => getTranslation(BodyModalLanguages, language, key);
  // Get all agents with ROLE_PUBLISHER
  let agentsOfGroup = membersOfGroup?.filter(member => member.role && member.role === "ROLE_PUBLISHER");
  
  // Apply team restriction for ROLE_PUBLISHER users
  if (currentUser?.role === "ROLE_PUBLISHER" && currentUser?.teamTagId && currentGroup?.hasTeams) {
    // Filter agents to only show those from the same team
    agentsOfGroup = agentsOfGroup?.filter(agent => {
      // Include agents from the same team
      if (agent.teamTagId === currentUser.teamTagId) {
        return true;
      }
      // Include agents without team (no restriction for them)
      if (!agent.teamTagId) {
        return true;
      }
      // Exclude agents from different teams
      return false;
    });
  }
  
  // Find currently assigned agent
  const agentAssigned = agentsOfGroup?.find(agent => {
    if(agent.tagId && contactSelected.userTagId) {
      return agent.tagId === contactSelected.userTagId;
    }
  });

  // Prepare options for react-select
  const options = [];
  
  // Add current agent option
  if (agentAssigned) {
    options.push({
      value: "",
      label: (
        <div className="d-flex justify-content-between align-items-center">
          <span className="mr-1">{agentAssigned.name} ({translate("CurrentAgent")})</span>
          {currentGroup?.hasTeams && (
            <div 
              style={{
                backgroundColor: agentAssigned.serviceStatus === 1 ? 'green' : agentAssigned.serviceStatus === 2 ? 'orange' : 'red',
                width: '10px',
                height: '10px',
                borderRadius: '50px'
              }}
            />
          )}
        </div>
      )
    });
  } else {
    options.push({
      value: "",
      label: translate("NoAgentAssigned")
    });
  }

  // Add other agents
  const otherAgents = agentsOfGroup?.filter(agentOfGroup => 
    !agentOfGroup.tagId || agentOfGroup.tagId !== contactSelected.userTagId
  ).map((agentOfGroup) => ({
    value: agentOfGroup.id,
    label: (
        <div className="d-flex justify-content-between align-items-center">
          <span className="mr-1">{agentOfGroup.name}</span>
          {currentGroup?.hasTeams && (
            <div 
              style={{
                backgroundColor: agentOfGroup.serviceStatus === 1 ? 'green' : agentOfGroup.serviceStatus === 2 ? 'orange' : 'red',
                width: '10px',
                height: '10px',
                borderRadius: '50px'
              }}
            />
          )}
        </div>
    )
  })) || [];

  options.push(...otherAgents);

  return (
    <ModalBody className="p-4">
      <Form>
        {(
          <FormGroup className="mb-4">
            <Label htmlFor="agent-select">
              {translate("AvailableAgents")}
            </Label>
            <Select
              value={options.find(option => option.value === agent) || options[0]}
              onChange={(selectedOption) => {
                setAgent(selectedOption.value);
              }}
              options={options}
              isSearchable={false}
              styles={{
                control: (provided) => ({
                  ...provided,
                  border: '1px solid #e6ebf5',
                  minHeight: '38px'
                })
              }}
            />
          </FormGroup>
        )}
      </Form>
    </ModalBody>
  );
}

export default BodyModal;
